import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { AuthService } from '../services/auth.service';
import { ToastService } from '../services/toast.service';
import { UtilsService } from '../services/utils.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  public readonly utils = inject(UtilsService);

  private readonly authService = inject(AuthService);
  private readonly transloco = inject(TranslocoService);
  private readonly toast = inject(ToastService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          if (event?.body && event.body?.errors) {
            const errors = event.body.errors;

            (errors ?? []).forEach((error: any) => {
              if (error?.message === 'SESSION_TIMEOUT') {
                this.toast.showToast('error', this.transloco.translate('msgTT.sessionTimeout'));
                this.authService.cleanUpLoginData();
              } else if (error?.message === 'NOT_AUTH') {
                const body = request.body;
                // if (body && body.query) {
                //   console.log('GraphQL Query:', body.query);
                //   console.log('Variables:', body.variables);
                //   console.log('Operation Name:', body.operationName);
                // }

                this.toast.showToast('error', this.transloco.translate('msgTT.pleaseLogin'));
                this.authService.cleanUpLoginData();
                this.utils.routeToLogin();
              } else if (error?.message === 'GUEST_GONE') {
                this.toast.showToast('error', this.transloco.translate('msgTT.sessionTimeout'));
                this.authService.cleanUpLoginData();
                this.utils.routeToRegister();
              } else {
                this.toast.showToast('error', `${error?.message}`);
              }
              // this.toast.showToast('error', `${error?.message} ${error?.extensions?.code})`);
            });
          }
        }
      }),
      catchError((err: HttpErrorResponse) => {
        if (err.error?.message === 'SESSION_TIMEOUT') {
          this.toast.showToast('error', this.transloco.translate('msgTT.sessionTimeout'));
          this.authService.cleanUpLoginData();
        } else if (err.error?.message === 'NOT_AUTH') {
          this.toast.showToast('error', this.transloco.translate('msgTT.pleaseLogin'));
          this.authService.cleanUpLoginData();
          this.utils.routeToLogin();
        } else if (err.error?.message === 'GUEST_GONE') {
          this.toast.showToast('error', this.transloco.translate('msgTT.sessionTimeout'));
          this.authService.cleanUpLoginData();
          this.utils.routeToRegister();
        } else {
          let message = `${err.error?.message}`;
          if (err?.status === 0) {
            message = this.transloco.translate('msgTT.connectionRefused');
          }

          this.toast.showToast('error', message);
        }

        return throwError(err);
      }),
    );
  }
}
